// import { Link } from 'react-router-dom';
// import logo from '../../assets/images/cherryhills.png';

// const Footer = () => {
//   return (
//     <footer className="bg-primary-dark text-white">
//       <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
//           <div>
//             <div className="flex items-center space-x-3 mb-4">
//               <img
//                 src={logo}
//                 alt="Cherryhills"
//                 className="h-12 w-18"
//               />
//               <span className="text-lg font-semibold">
//                 <span className="text-orange-500">Cherry</span>{" "}
//                 <span className="text-green-600">Hills</span>
//               </span>
//             </div>
//             <p className="text-gray-400 text-sm leading-relaxed mb-6">
//               A leading portfolio management firm delivering institutional-grade investment solutions with personalized service and proven expertise.
//             </p>
//             <div className="flex space-x-4">
//               <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary-orange transition-colors cursor-pointer" aria-label="LinkedIn">
//                 <i className="ri-linkedin-fill text-lg"></i>
//               </a>
//               <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary-orange transition-colors cursor-pointer" aria-label="Twitter">
//                 <i className="ri-twitter-x-fill text-lg"></i>
//               </a>
//               <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary-orange transition-colors cursor-pointer" aria-label="Facebook">
//                 <i className="ri-facebook-fill text-lg"></i>
//               </a>
//             </div>
//           </div>

//           <div>
//             <h4 className="text-sm font-semibold uppercase mb-4">Services</h4>
//             <ul className="space-y-3">
//               <li><Link to="/services/wealth-management" className="text-gray-400 text-sm hover:text-primary-orange transition-colors cursor-pointer">Wealth Management</Link></li>
//               <li><Link to="/services/portfolio-advisory" className="text-gray-400 text-sm hover:text-primary-orange transition-colors cursor-pointer">Portfolio Advisory</Link></li>
//               <li><Link to="/services/retirement-planning" className="text-gray-400 text-sm hover:text-primary-orange transition-colors cursor-pointer">Retirement Planning</Link></li>
//               <li><Link to="/services/estate-planning" className="text-gray-400 text-sm hover:text-primary-orange transition-colors cursor-pointer">Estate Planning</Link></li>
//             </ul>
//           </div>

//           <div>
//             <h4 className="text-sm font-semibold uppercase mb-4">Company</h4>
//             <ul className="space-y-3">
//               <li><Link to="/about" className="text-gray-400 text-sm hover:text-primary-orange transition-colors cursor-pointer">About</Link></li>
//               <li><Link to="/about#team" className="text-gray-400 text-sm hover:text-primary-orange transition-colors cursor-pointer">Team</Link></li>
//               <li><Link to="/contact" className="text-gray-400 text-sm hover:text-primary-orange transition-colors cursor-pointer">Contact</Link></li>
//               {/* <li><a href="#" className="text-gray-400 text-sm hover:text-primary-orange transition-colors cursor-pointer">Careers</a></li> */}
//             </ul>
//           </div>

//           <div>
//             <h4 className="text-sm font-semibold uppercase mb-4">Resources</h4>
//             <ul className="space-y-3">
//               <li><Link to="/insights" className="text-gray-400 text-sm hover:text-primary-orange transition-colors cursor-pointer">Insights</Link></li>
//               {/* <li><a href="#" className="text-gray-400 text-sm hover:text-primary-orange transition-colors cursor-pointer">Market Reports</a></li> */}
//               <li><a href="#" className="text-gray-400 text-sm hover:text-primary-orange transition-colors cursor-pointer">FAQ</a></li>
//             </ul>
//           </div>
//         </div>

//         <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
//           <p className="text-gray-400 text-sm">&copy; 2024 Cherryhills. All rights reserved.</p>
//           <div className="flex items-center space-x-6 mt-4 md:mt-0">
//             <a href="#" className="text-gray-400 text-sm hover:text-primary-orange transition-colors cursor-pointer">Privacy Policy</a>
//             <span className="text-gray-600">|</span>
//             <a href="#" className="text-gray-400 text-sm hover:text-primary-orange transition-colors cursor-pointer">Terms of Service</a>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;





import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import defaultLogo from '../../assets/images/cherryhills.png';
import companylogo from '../../assets/chil.png';
const Footer = () => {
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(() => {
    fetch('https://cherry.dealdrivetechnology.com/api/v1/public/company-info')
      .then(res => res.json())
      .then(data => {
        if (data.success) setCompanyInfo(data.data);
      })
      .catch(err => console.error("Footer fetch error:", err));
  }, []);

  return (
    <footer className="bg-primary-dark text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src={companylogo}
                // alt={companyInfo?.companyName || "Logo"}
                alt="Company Logo"
                className="h-12 w-auto"
              />
              {/* <span className="text-lg font-semibold uppercase tracking-wider">
                {companyInfo?.companyName || "Cherry Hills"}
              </span> */}
            </div>
            {/* <p className="text-gray-400 text-sm leading-relaxed mb-6">
              {companyInfo?.description || "A leading portfolio management firm delivering institutional-grade investment solutions."}
            </p> */}
            <div className="flex space-x-4">
               {/* Socials can be made dynamic if added to API later */}
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary-orange transition-colors cursor-pointer"><i className="ri-linkedin-fill"></i></a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary-orange transition-colors cursor-pointer"><i className="ri-twitter-x-fill"></i></a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase mb-4">Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-gray-400 text-sm hover:text-primary-orange transition-colors">All Services</Link></li>
              <li><Link to="/services" className="text-gray-400 text-sm hover:text-primary-orange transition-colors">Wealth Management</Link></li>
              <li><Link to="/services" className="text-gray-400 text-sm hover:text-primary-orange transition-colors">Portfolio Advisory</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase mb-4">Contact</h4>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="flex items-center gap-2"><i className="ri-mail-line text-primary-orange"></i> {companyInfo?.email || "info@company.com"}</li>
              <li className="flex items-center gap-2"><i className="ri-phone-line text-primary-orange"></i> {companyInfo?.phone || "+44 ..."}</li>
              <li className="flex items-start gap-2"><i className="ri-map-pin-line text-primary-orange"></i> {companyInfo?.address || "London, UK"}</li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase mb-4">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-400 text-sm hover:text-primary-orange transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-400 text-sm hover:text-primary-orange transition-colors">Work With Us</Link></li>
              <li><a href="#" className="text-gray-400 text-sm hover:text-primary-orange transition-colors">Privacy Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">© {new Date().getFullYear()} {companyInfo?.companyName || "Cherryhills"}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;